module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("V")])]), _vm._v("alens watched the trio hobble off until they were submerged in the growing throng—Julia’s head the highest of the three and her shawl easy to follow in the crowd. She was quite unexpected. The odour of her perfume lingered in the air—a light floral scent of lavender mingled with roses and somehow suitable for the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He ran his hand through his hair. He had a thousand things to do, to prepare, and wasting time speculating about a woman was not going to help. This one last fight on the biggest stage in the world, and then he’d retire…with honour. But he’d seen far too often what happened to those who failed to concentrate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens pulled his cloak more firmly around his shoulders and hunched his head against the rain. Out of the corner of his eye, he spotted a small stone flask wedged between two paving stones. He picked it up—I.A. was faintly scratched on the top. Julia Antonia? He glanced towards the direction he had last seen her, weighing the flask in his hand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("‘Excuse me, excuse me but is that a gladiator’s badge?’ a young boy lisped, pulling on his cloak. ‘I saw some gladia")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("tors fight last year in Capua with my father. And the spectacle was fantastic. Which sort of gladiator are you? I collect the figures. I have a Samnite, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rentarius")]), _vm._v(" and my mother just bought me a Valens the Thracian figurine whose arms can move.’")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens glanced down at the boy’s upturned face, glowing with admiration, and then back to where Julia had disappeared. He shoved the flask into his belt. There would be time later to find her if the Fates were willing. Back to being a god.")]), _vm._v(" "), _c('p', {
    staticClass: "para2",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia chewed the end of her stylus, trying to think of a way to describe her encounter with Valens the gladiator to Claudia. Without a doubt, Claudia would have a hundred questions that as a dutiful best friend she should answer before she was asked. The problem was she had little idea of how to answer. She only knew he was a Thracian gladiator, but not if a Thracian was a great or little shield. Claudia was an avid supporter of the great shields, the ones who were nearly covered in body armour and carried the oblong shields, if she remembered correctly. Thracian would have to do. She sighed and pushed the tablet away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I know, Bato,’ she said to the elderly greyhound who whined at her from his place by the brazier. ‘But what is the point of writing when I am ignorant of so many things Claudia will demand to know?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dog gave a sharp bark and covered his nose with his paws. Julia laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Exactly what I’ll do when Claudia demands further and better details.’ She picked up her stylus again and started to write. Before she had written three words, a loud banging and shouts sounded outside. ‘What is that unearthly racket, Bato? Have a whole host of Furies descended on the courtyard?’")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She limped to the door, only to have it pulled out of her hand by Sabina, her stepmother’s face contorted in fury.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now you’ve done it, Julia. You have done it. Listen to that racket! Just you wait until your father gets home.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What is it, Sabina?’ Julia crossed her arms and stared at her stepmother. Julia’s mind raced, trying to think what she had done to cause this red-faced anger. Nothing. But that small fact seemed to have escaped the older woman. ‘Ever since we arrived back from the baths, I’ve been in that room, resting my ankle and writing letters. I’m totally innocent of whatever is happening out there.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sabina’s mouth opened and closed like a codfish several times before she emitted a piercing shriek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That gladiator you talked to this morning, outside the baths. He’s at the gates.’ Sabina shook at finger at Julia. ‘I will not have your brutish friends intimidating the porter. I won’t have it, I tell you. You may speak to them in the marketplace, but I refuse to have an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("infamis")]), _vm._v(" in the house. Gladiators are the lowest of the low. They are even worse than actors. And, by Juno’s necklace, you know how many times I have refused to allow them in my house, even for entertainment!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is he?’ Julia’s fingers went to her throat. Valens here! A warm glow filled her as she remembered the way his hands had engulfed her ankle. She tried for a casual shrug of her shoulders. ‘He’s probably found my missing flask of perfume and is returning it, that’s all. There is no need for you to put the house in an uproar.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("‘He thinks you invited him to stay.’ Sabina had a triumphant gleam in her eye. ‘Julia, your father will be furious with you. I dread to think what Senator Mettalius will say when he finds out. You take his proposal of marriage too lightly, ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Julia. Many women would be delighted to ally their families with Mettalius. He’s a rising star in the Senate.’")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where is my father?’ Julia asked, thinking fast as her stomach hit the tops of her sandals. Had she said something, anything Valens could take for invitation? She went back over the conversation. Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He retired to the gym two hours ago. Perhaps, your luck will hold, but I’d make a shrewd guess and say you have less than a half-hour to get rid of your lovelorn gladiator friend before your father returns and Mettalius comes for dinner.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mettalius is dining with us. Nobody told me.’ Julia wrinkled her nose and her mind raced to think of a suitable excuse. This day was getting worse with each passing word from Sabina’s lips. Perhaps her ankle would be too painful and she’d retire to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He sent word at five hours, just before we left for the baths. I want you to look your best. I will not accept any excuse. Your last one about your dog being ill was utterly transparent. Your father knows what is best for you and the family. Think of Mettalius’s power, his influence.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His bad breath? His high-pitched voice? Julia resisted the temptation to add these attributes to the list.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Furthermore, if you cross me on this, I will…I will have that dog of yours put down.’ Sabina’s eyes narrowed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bato bared his teeth and gave a low growl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You wouldn’t dare.’ Julia curled her fingers around Bato’s collar. She gave a wild look at Sabina, standing there, one hand on her hip, the other pointing at Bato. ‘Hush, Bato, be good. She’s only having her little joke.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Try me.’ Sabina made a shooing motion. ‘Now, go and get rid of the gladiator. Then we’ll talk, and remember what happened the last time you tried to get the better of me.’")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia clenched her jaw. She remembered all too well what happened—Sabina had consulted her favourite augur and she had been married off to Lucius before she had had a chance to voice a protest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She covered her letter to Claudia with several scrolls, then placed her stylus on top. The last thing she needed was Sabina prying into her private letters. She snapped her fingers. ‘Come, Bato. We have a gladiator to disable.’")]), _vm._v(" "), _c('p', {
    staticClass: "para2",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens stood with his tablet in his hand, his foot blocking the porter from shutting the huge iron-and-oak door. The pain between his eyes had reached a crescendo. After he had answered an ever-growing crowd of supporters’ questions, he arrived back late to the School’s temporary headquarters only to discover the memories of Spartacus’s rebellion cast long shadows. The Senate had passed a law forbidding more than three gladiators to be housed in one place. And Strabo wanted the situation sorted out yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now, all he wanted to do was leave his gear, find the nearest public baths before they closed and try to soak some of today’s problems away. It was highly unlikely that this family would have its own private bathing suite, because as far as he could tell, they were equestrian, rather than senatorial in stature.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had seemed straightforward when he left Strabo and Caesar. Unfortunately, the place where he was supposed to stay seemingly had no knowledge of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The fine drizzle dripped on the back of his neck, echoing his mood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But I’m expected,’ he explained again to the grizzled porter cowering behind his table. For Hercules’s sake, he had kept his voice low and deadly calm. The man behaved as if he had tried to strike him. He only wanted to go to his room.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I know nothing about this—’ the porter said in an officious tone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s fine, Clodius. I will handle this,’ a firm but melodious voice said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens raised his eyebrows in surprise. The matron from the marketplace. Julia Antonia. Another sign from the gods?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A shaft of sunlight appeared through the clouds, lighting the doorway and the woman standing in it before vanishing. She looked lovelier than he remembered. No longer covered in a mantle, her hair had a dark black sheen like the wing of a blackbird he had once owned as a boy. Her movements reminded him of that bird—quick, sharp, nervous. At first, the bird had pecked his finger, but after his mother had shown him how to be patient, the bird had taken crumbs from the palm of his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘At last, someone with a bit of common sense.’ Valens made his voice sound playful but there was no relaxation of her shoulders, no answer to his smile. If anything, she looked more wary. There had to be something he could use to recapture the camaraderie of the marketplace. He frowned and reached into his satchel. ‘I found your perfume flask. It had rolled a little way along the gutter.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He held it out as if he were holding crumbs for his blackbird. At the sight of the flask, a cloud seemed to lift from her face, and she gave a smile that could have lit a thousand lamps. Cautiously she stretched out her hand. Her cool fingers closed around the flask, touched his and sent a jolt up his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes traced the relaxed curve of her neck before locking with her sober hazel eyes. Valens’s lips curved upwards into a smile of triumph—he had her tamed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("A slim greyhound peered from behind her skirts, and then ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("raced forward, breaking Valens’s gaze, returning him to the present. The dog’s cool muzzle touched Valens’s hand, his tongue lapping at his palm. Valens reached down and stroked the dog’s ears. Instantly the dog gave a whine of pleasure, turned over and wriggled on its back, exposing its belly and nudging Valens’s leg.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Bato, come back here,’ Julia said, tugging on the dog’s collar and her face growing bright red. ‘I’m so sorry. He’s normally very wary of people, men in particular. I can’t think why he should behave like that. Bato, sit!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dog gave another lap of his tongue—this time to Valens’s sandal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens went still. For a breath, he thought he knew the dog. It reminded him of one he’d left with his father before he went off to fight in North Africa more than five years ago. But that would be too much of a coincidence. He shook his head at his folly. The poor thing probably smelt the pie he had had for lunch. Mystery solved.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It is quite all right. No harm done,’ he said. ‘I like dogs, in particular greyhounds. I used to have one as a pet when I was a boy. Have you had Bato since a puppy?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia gave a wistful smile and her shoulders tensed. The blackbird look was back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He belonged to my ex-husband, but Bato tired of my ex’s uncertain temper, decided he was my dog and took to defending me against my ex. When I left, he came with me. Except when I am at the baths, he is rarely more than a few feet from me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her words held a wealth of hidden agony. It was no wonder she looked poised for flight, Valen thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘A wise dog.’ He lifted one eyebrow and watched her cheeks stain with colour. A small laugh escaped her lips.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He regarded Julia with the practised eye of someone whose life depended on reading other people correctly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The muscles had relaxed and she held her shoulders less defensively. He followed the line of her softly caught-up hair to where the curl brushed her neck. Her lips curved into a soft smile, rather than the rigid expression she had had when she had first appeared in the doorway, but her eyes were wary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One or two more nuggets of carefully controlled conversation, and she should be at her ease. After that he’d introduce why he was here. He hoped she actually knew how to read.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave Bato one last pat. ‘A very wise dog to stay so close to your mistress.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia tilted her head to one side, and stared at him, trying to assess the situation. She had to find out why he was here. It had to be more than the flask she held in her palm. They could not stand here making polite conversation about Bato all day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His blue cloak billowed slightly and she could see his massive chest, barely contained in the white woollen tunic. The damp had made his dark hair curl at his temples. Her eyes travelled up to his face and met his dark brown eyes. The gaze held for a breath before she dropped her glance and examined the flask in her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked as if he were free from furies and demons, but appearances could be deceptive. She had thought Lucius was kind and considerate until they married and she had had to witness his rages.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She played with the lid to the flask, twisting it back and forth, as she waited for him to state his reason for being here. Silence. She peeped again at his shoulders, and thought of the strength that must be in those arms, the way he could slay men with a single slice of a sword.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A shiver ran down her back. Perhaps she ought not to have come out. She should have let Clodius handle it. It was his job, after all, to vet callers. But Clodius had disappeared, leaving her exposed and vulnerable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took a step backwards towards the safety of the house and winced as pain shot through her bad ankle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I forgot to ask—how is your ankle?’ he said, putting his hand on her elbow and steadying her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sensation darted up her arm, making her heart pound faster. Her breath came in short gasps, as if she had just finished an arduous exercise session at the baths.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My ankle?’ Julia swallowed hard, warmth spread like a fire from his hand infusing her body with its sweet languor. He wasn’t supposed to ask about her ankle. He had returned her flask. He was supposed to make his excuses and leave. ‘It is getting better. I rested it this afternoon.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Have you had someone look at it? It might need treatment. I can arrange for—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There is no need—’ Julia broke in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Out of the corner of her eye, she saw Sabina advancing, her stiff curls shaking with rage. Julia pressed her lips together and shook her head. If she needed reinforcements, she’d call for them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But it is no bother,’ he pressed. ‘Proper medical treatment can make a world of difference. Too often in my line of work I’ve seen men die, because they trusted the soothsayer or augur rather than the surgeon. Thankfully, the gladiator school I belong to employs a medical team to oversee all aspects of training. I’ll ask my surgeon to have a look at it for you. He’s an expert on breaks.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Julia rubbed the back of her neck. Dismissing him was proving far harder than she had anticipated. Her heart kept ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("whispering to her to prolong the encounter, to enjoy feeling that someone might be interested in her welfare. But was it worth risking her father’s wrath?")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The beginnings of a headache pounded between her eyebrows. She shook her head and refused to let confusion take hold of her tongue. She had to get rid of the man, no matter how much her heart wanted him to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you for the offer but I would hate to think I put you to any trouble.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It will be no trouble at all. Apollonius will be visiting here later. He has to make sure my diet will be adequately catered for. The problems this new law has caused. Luckily Caesar spotted the Senate’s move before it happened.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia felt an ice-cold finger creep down her spine at his words. His diet catered for? The headache crashed over her in full force. She swallowed hard and reached out a hand to grasp the doorframe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m sorry, but I think I misheard you. Why would we be catering for your diet?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Because this is where I am staying.’ Valens looked at her as if she had lost her mind. ‘It has been all arranged.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia stared at the tall gladiator, unable to believe what she had just heard. She had begun to hope that perhaps Sabina had been mistaken. But his words confirmed her worse fears. Somehow, she had inadvertently invited him. She’d have to bluff it out, get rid of him before her father returned. Make him understand it was a mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Pardon me? Is this another one of your not-so-amusing jokes? If so, it is even less likely to raise a smile than the last one. I never invited you here. Of course, if you want something for bringing my flask back…’ Julia started to fumble with her arm purse.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She paused. Her actions made it seem as if she came from the same mould as Sabina. He wasn’t some servant or a street child to be given a token in exchange for a small service. He was a successful gladiator.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There is no need for that. It was my pleasure. I was only too glad to find it.’ Valens waved his hand and then stared at a tablet. ‘This is the villa of Julius Antonius, the lawyer, isn’t it?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It is.’ Julia folded her arms and braced her legs. He’d have to move her from the threshold, before she let him cross.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He is a client of Julius Caesar, who is the current Aedile in charge of the games and public entertainment, the man sponsoring my gladiatorial school?’ Valens spoke slowly as if she were some half-witted child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She released a pent-up breath in one great whoosh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Caesar is our second cousin, but I don’t see what that has to do with anything,’ she said carefully, her mind starting to whirl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was more going on here than a simple misunderstanding. Her hand twisted the necklace of blue stones around her throat. How like Sabina, not to give her the full story and to send her to accomplish a task Sabina didn’t have the stomach for. If Caesar was involved, it would be unthinkable to refuse, even if she wanted to. Caesar was her father’s most important patron, providing most of the clients for his law practice. Her father always acceded to Caesar’s wishes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("‘The Senate has decreed this morning that large groups of gladiators living together pose a threat to the city’s security, citing Spartacus’s rebellion of seven years ago. Caesar looks on this as a direct attack on his integrity as Aedile and feels it is an attempt by his rivals to discredit him. Therefore, he has requested your father to house a gladiator for the dura")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("tion of the games,’ Valens said, holding out a tablet. ‘I am that gladiator.’")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia took the tablet and read the words in Caesar’s very distinctive script. She reread the words and glanced back at Sabina, whose face was growing more thunderous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not this time, Stepmother dear.")]), _vm._v(" If she wanted to cross Caesar, she did it herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My father knows about this?’ she asked, tapping the tablet against her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I was given to understand he did,’ Valens said, lifting one eyebrow. ‘Caesar is the most efficient man I have ever served. Within two hours of the law being passed, he had found places for over a hundred men. I see no reason to doubt his word.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia bit her lip. What to do? She could see Sabina watching from inside the courtyard, making ever-increasing shooing motions. Julia shook her head at her for a second time. Let her father deal with Sabina’s shrieks and wails when he came home. How like her father—desperate to avoid a confrontation with Sabina, he had disappeared until the storm had blown over, leaving others to sort out the mess. Her father and Sabina could be infuriatingly similar in their ways of dealing with uncomfortable situations.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I can understand that—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is there some sort of problem?’ Valens asked, his eyes showing concern and something else. ‘If you’d like, you can always send a runner to check with Caesar’s house. I’m sure you will find everything in order.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There will be no reason to trouble Caesar with this,’ she said in an overloud voice. ‘I have seen his hand before. If Caesar requires his clients to house gladiators, who am I to question?’")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Out of the corner of her eye, she saw Sabina shrink back at the invocation of Caesar. Despite her pretensions, Sabina was well aware how much their present prosperity was dependant on Caesar’s continued generosity. How Sabina’s most-prized possession, the bathing suite with its expensive mosaics, was a direct result of Caesar involving her father in several lucrative lawsuits. Lawsuits that would vanish overnight if her father crossed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It will be our pleasure to honour Caesar’s request and provide a room for you,’ she said, turning back to Valens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I knew you were a woman of learning as well as sense,’ he said and his voice flowed over her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens’s smile made her pulse race and drove all coherent thought from her mind. Her hand shook as she tightened her hold on Bato’s collar. It was no good telling her heart that he smiled like that all the time. Her heart was certain it was for her and her alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you, thank you very much,’ Julia stammered out and then tried to calm her thumping heart. ‘I shall take it as a compliment.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It was meant as one.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘First my ankle and now my intellect. Does idle praise always slip off your tongue with such ease?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I beg to differ. I merely state the obvious.’ His eyes twinkled. ‘I always tell the truth about such things.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia pretended to reread the tablet. She was no good at flirting games. She had to change the subject, get her mind off him and onto the problem at hand—this gladiator’s accommodation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Caesar gave no indication of the rank he was supposed to hold in the house. She could hardly place him with the slaves and run the risk of causing offence to their most important pa")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("tron. She wanted something to enhance their reputation with Caesar and to make up for the welcome Valens had so far received.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tapped the tablet against her hand, her lips curving upwards. She’d teach Sabina to threaten her. She’d enjoy watching Sabina squirm for once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Clodius, please show our guest to the best chamber.’ Julia made sure her voice carried and watched the colour drain from Sabina’s face. ‘What Caesar asks for, we should grant. He’d hardly go to all this trouble unless he wanted us to treat Valens as our honoured guest.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Julia.’ Sabina’s indignant whisper carried as she marched over to Julia. The sound of her sandals striking the paving stones echoed throughout the courtyard. ‘Did I hear you order Clodius to show this gladiator to our best bedchamber? Surely the stables would have been good enough for one such as him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Caesar’s request, Stepmother.’ Julia waved the tablet under the older woman’s nose. Threaten to put Bato down, would she? ‘I’m sure anything less would be looked on as a slight by Caesar. And I would hate to tell my father we slighted his greatest patron. But if those are your orders…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You are right. Of course you’re right.’ Sabina wrung her hands and looked distracted. ‘I know you’re right. What am I to tell Mettalius Scipio? I had rather hoped he would stay the night…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Mettalius Scipio. Valens froze. The name opened cracks in his memory, sent his mind along forgotten paths. Images of forts and the tribune issuing orders, of the dark night and the breath of his men as they waited, of the ambush and then finally of the hook-nose pirate who had captured him and then spat in his face, crowded into his brain. Images he thought he ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("had buried years ago when he first wielded the gladiator’s sword.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mettalius Scipio, son of Mettalius Agrippa?’ Valens asked, making an effort to keep his voice steady.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why, yes,’ Julia’s stepmother simpered. ‘Do you know the senator? Julia is about to become betrothed to him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We’ve met…several times.’ He knew instinctively his words would be interpreted as meaning recently when in fact it was five years since they had last spoken. Valens closed the door to his memory with a bang. He refused to remember anything about the time before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That puts a rather different complexion on the whole thing, doesn’t it? I mean, if you are a friend of senators…’ She held out her hand, batting her false eyelashes. ‘I’m Sabina Claudia, the wife of Julius Antonius. Julia is my stepdaughter, in case you didn’t guess. I must apologise for her—Julia can be too cautious at times, too apt to judge people by their standing, if you know what I mean. Too proud for her own good.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not at all like you,’ Valens said and made an effort not to wince as he said the words.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sabina Claudia was one of those dyed blondes with paint so thick on her face her very features were obscured, one of those women whose sole purpose was to grasp the next rung of the social ladder, kicking anyone and everyone as they scrambled over them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I am positive you are the soul of tact,’ Valens added pointedly. ‘A reflection of the true Roman-matron ideal.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bato the dog gave him a strange look, and Valens bowed back. He ignored Julia’s questioning glance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("‘Julia, why didn’t you tell me your gladiator was so perceptive in addition to having such a fine Italian accent? He ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("could almost pass as someone other than a gladiator,’ Sabina cooed, hooking her arm through Valens’s. ‘Now you must try our bath suite. It has the latest word in luxury—a hot plunge bath. I made certain of that, and that is undoubtedly why Caesar chose us for your lodgings. He knew we could provide the facilities you needed, unlike others I could mention.’")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens detached himself as unobtrusively as he could. Julia looked as if she was about ready to explode. At him? At her stepmother? Valens gave a slight nod in her direction, but Julia looked away, chin very firmly in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’s not my gladiator, Stepmother. I explained to you already that we had barely met.’ Her voice dripped ice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘A figure of speech, my dear,’ her stepmother replied airily. ‘At least you had the good sense to run into a gladiator who is well connected.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I…’ Julia said and then turned on her heel and limped off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Valens watched her go, the skirt of her gown swishing at her heels. He admired the way she kept her head held high and did not stoop to dignify her stepmother’s remark with an answer. She reminded him of the sort of woman he had dreamt of marrying years ago. The sort of woman who had helped make Rome great and who was for ever beyond his reach. One who did embody the ideals of Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I had no idea Julia Antonia was betrothed to Senator Mettalius,’ he said, turning once again to Sabina, his anger growing at the stupidity of the woman, at his folly for wanting something he could not have and at his desire to remember the past.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course, nothing is settled yet, but we are very hopeful. The senator appears to be willing.’ Sabina’s voice dropped to a hushed whisper. ‘All things considered, Julia can not be choosy.’")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Indeed?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I am sure you will hear anyway, seeing as you will be staying here. The servants will talk.’ Sabina gave a large mock sigh. ‘Julia left her husband. She divorced him, claiming he had beaten her. She even took his dog. Her father was most upset. He had to take her back in, of course. She couldn’t be left out in the street and she is his responsibility. I did tell him when they married that she is a flighty over-indulged child and might do this. Would he listen and marry her with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("confarreatio")]), _vm._v(", giving her to her husband for ever, relinquishing all authority over her? No, he gave into fashion. Now he is faced with an unmarried twenty-one-year-old with the wisp of scandal clinging to her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stolla.")]), _vm._v(" All the best alliances have gone. What sort of man wants a wife that will argue back?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mettalius, obviously,")]), _vm._v(" Valens thought but resisted the temptation to say it aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now, if you’ll have a servant show me to my quarters and to your bathing suite, I’ll trouble you no further. I’ve had a long day.’ He gave a slight bow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But you will join us for dinner.’ Sabina gave a coquettish smile. ‘We’re having sow’s udder. It is a speciality of mine, a recipe handed down from generation to generation. The senator always compliments me on it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Regrettably, no, I follow a very strict diet in the weeks before a bout, eating mainly barley and beans.’ Valens bowed and forced his tone to hold a note of regret. Sow’s udder had never been a favourite, even in the days before he’d been a gladiator. ‘I tend to take my meals on my own. Or with the others from the gladiatorial school. Caesar has no wish to trouble you any more than he has to.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Some other time.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("‘Perhaps, but I will give you longer notice as I don’t wish ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("to put you to any trouble,’ Valens said smoothly, making sure nothing betrayed his disquiet.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had no idea how he’d react if he had to confront Mettalius over the dinner table. Already the memories of those last days in North Africa were crowding again into his mind, driving other thoughts away. Valens frowned, and concentrated on turning his thoughts towards the games. His future depended on forgetting his past.")])])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page38"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c1ad5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459229921_ch02.vue
// module id = 81
// module chunks = 0